// client/src/components/world/SurfaceMinimap.jsx
// Итерация 6.3: миникарта поверхности (планета / спутник / астероид).
// Пока заглушка — ждём surface_objects от backend (Распоряжение №12, п. 2.5).

import React from 'react';
import { Box, Typography, Alert, Chip } from '@mui/material';
import { Public as PublicIcon } from '@mui/icons-material';

export default function SurfaceMinimap({ locationInfo, characterMeta }) {
  const surfaceObjects = locationInfo?.surface?.objects;
  const hasData = Array.isArray(surfaceObjects) && surfaceObjects.length > 0;

  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 1.5,
        bgcolor: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
        <PublicIcon sx={{ color: '#4a7fb5', fontSize: 14 }} />
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.6rem', flex: 1 }}>
          🌍 Поверхность
        </Typography>
        {locationInfo?.name && (
          <Chip
            label={locationInfo.name}
            size="small"
            sx={{ height: 14, '& .MuiChip-label': { fontSize: '0.4rem', px: 0.5 } }}
          />
        )}
      </Box>

      {!hasData && (
        <Alert severity="info" sx={{ py: 0, fontSize: '0.55rem' }}>
          Данные о поверхности ещё не поступают с сервера (Итерация 6.5)
        </Alert>
      )}

      {hasData && (
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio: '1 / 1',
            maxHeight: 200,
            bgcolor: 'rgba(0,0,0,0.3)',
            borderRadius: 1,
            border: '1px solid rgba(255,255,255,0.05)',
          }}
        >
          {/* TODO: 2D canvas с точкой персонажа и объектами */}
          <Typography
            variant="caption"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '0.5rem',
              color: 'text.secondary',
            }}
          >
            Миникарта поверхности ({surfaceObjects.length} объектов)
          </Typography>
        </Box>
      )}
    </Box>
  );
}
